export const mapStatus = {
  DRAFT: "แบบร่าง",
  WAIT_APPROVE: "รออนุมัติ",
  WAIT_ACTIVE: "รอเปิดใช้งาน",
  ACTIVE: "เปิดใช้งาน (Live)",
  INACTIVE: "ปิดใช้งาน",
  EXPIRED: "หมดอายุ",
};
export const mapBgColor = {
  DRAFT: "#F3F6F9",
  WAIT_APPROVE: "#FFEBDB",
  WAIT_ACTIVE: "#EEF6FE",
  ACTIVE: "#E2FDEB",
  INACTIVE: "#BABCBE",
  EXPIRED: "#EFF2F9",
};
export const mapTextColor = {
  DRAFT: "Text1",
  WAIT_APPROVE: "warning",
  WAIT_ACTIVE: "primary",
  ACTIVE: "EmeraldGreen",
  INACTIVE: "white",
  EXPIRED: "Gray",
};

export const mapStatusRound = {
  COMING: "รอเริ่ม",
  WAIT: "ยังไม่เริ่ม",
  ENDED: "จบรอบ",
  LIVE: "กำลังขาย (Live)",
  DISABLED: "ปิดใช้งาน",
};
export const mapTextColorRound = {
  COMING: "warning",
  WAIT: "Gray",
  ENDED: "Gray",
  LIVE: "EmeraldGreen",
  DISABLED: "white",
};
export const mapBgColorRound = {
  COMING: "#FFEBDB",
  WAIT: "#EFF2F9",
  ENDED: "#EFF2F9",
  LIVE: "#E2FDEB",
  DISABLED: "#BABCBE",
};
export const mapQuotaType = {
  QUOTA_TOTAL: "โควตารวม",
  QUOTA_INDIVIDUAL: "โควตารายร้าน",
  QUOTA_NONE: "ไม่มีโควตา",
};
